import React from "react";
import Header from "../Components/Header/Header";
import ProfileNav from "../Components/Profile/ProfileNav";

const ProfilePage = () => {
  return (
    <div>
      <Header />
      <ProfileNav />
    </div>
  );
};

export default ProfilePage;
